import React from "react";
import { Link, useNavigate } from "react-router-dom";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

export const AboutCountryAustralia = () => {
  const navigate = useNavigate();

  const AustraliaData = {
    title: "Study Abroad Opportunities Australia",
    mTitle: "Why Study in the Australia?",
    desc_1:
      "Australia’s education system is globally recognized for its high standards and innovative approach to teaching. With a reputation for excellence, Australia offers a diverse range of programs across its world-class universities, making it an attractive destination for students seeking to study abroad. The country's strong emphasis on research and practical skills equips students with the tools they need to excel in their chosen fields. Whether you’re interested in engineering, medicine, business, or the arts, Australian institutions provide an education that is both comprehensive and forward-thinking.",
    desc_2:
      "In addition to its academic strengths, Australia is known for its multicultural society and welcoming atmosphere. The natural beauty of the country, combined with its vibrant cities and outdoor lifestyle, offers a unique balance between academic rigor and quality of life. Studying in Australia not only enhances your knowledge but also provides a life-changing experience that broadens your horizons and prepares you for global opportunities.",
  };

  const AustraliaBenefits = [
    { title: "World-Class Education", number: 550, suffix: "+" },
    { title: "Diverse Academic Programs", number: 100, suffix: "%" },
    { title: "Top-Ranked Universities", number: 300, suffix: "+" },
    { title: "Strong Industry Connections", number: 550, suffix: "+" },
  ];

const AustraliaUniversities = [
  { title: "Bond University", img: "/image/study-abroad/aus/bond-university.png", link: "#" },
  { title: "Charles Darwin University (CDU)", img: "/image/study-abroad/aus/charles-darwin-university.png", link: "#" },
  { title: "Deakin University", img: "/image/study-abroad/aus/deakin-university.png", link: "#" },
  { title: "Federation University", img: "/image/study-abroad/aus/federation-university.png", link: "#" },
  { title: "Flinders University", img: "/image/study-abroad/aus/flinders-university.png", link: "#" },
  { title: "Griffith University", img: "/image/study-abroad/aus/griffith-university.png", link: "#" },
  { title: "La Trobe Melbourne (Navitas)", img: "/image/study-abroad/aus/la-trobe-melbourne.jpg", link: "#" },
  { title: "RMIT", img: "/image/study-abroad/aus/rmit.png", link: "#" },
  { title: "Swinburne University of Technology", img: "/image/study-abroad/aus/swinburne-university-of-technology.png", link: "#" },
  { title: "The University of Newcastle", img: "/image/study-abroad/aus/the-university-of-newcastle.png", link: "#" },
  { title: "University of Canberra", img: "/image/study-abroad/aus/university-of-canberra.png", link: "#" },
  { title: "University of Melbourne", img: "/image/study-abroad/aus/university-of-melbourne.png", link: "#" },
  { title: "University of New South Wales", img: "/image/study-abroad/aus/university-of-new-south-wales.png", link: "#" },
  { title: "University of Queensland", img: "/image/study-abroad/aus/university-of-queensland.png", link: "#" },
  { title: "University of South Australia", img: "/image/study-abroad/aus/university-of-south-australia.png", link: "#" },
  { title: "University of Southern Queensland", img: "/image/study-abroad/aus/university-of-southern-queensland.jpg", link: "#" },
  { title: "University of technology sydney", img: "/image/study-abroad/aus/university-of-technology-sydney.png", link: "#" },
  { title: "University of Wollongong", img: "/image/study-abroad/aus/university-of-wollongong.png", link: "#" },
  { title: "Victoria University", img: "/image/study-abroad/aus/victoria-university.png", link: "#" },
  { title: "Western Sydney University", img: "/image/study-abroad/aus/western-sydney-university.png", link: "#" }
];

  const responsiveCarousel = {
    desktop: { breakpoint: { max: 3000, min: 1024 }, items: 4 },
    tablet: { breakpoint: { max: 1024, min: 600 }, items: 2 },
    mobile: { breakpoint: { max: 600, min: 0 }, items: 1 },
  };

  return (
    <div className="max-w-7xl mx-auto px-4 py-12">
        <style>
        {`
          .react-multiple-carousel__arrow {
            margin-left: -45px;
            margin-right: -45px;
          }
          
        `}
      </style>

      {/* Hero Section */}
      <section className="mb-12">
        <h1 className="text-4xl font-bold text-indigo-700 mb-6">
          {AustraliaData.title}
        </h1>

        {/* Carousel After Main Title */}
        <div className="mb-10 mt-10">
<h3 className="text-2xl font-semibold text-indigo-600 mb-5 mt-5 ">Top Universities in the Australia</h3>
        <p className="text-gray-600 mb-6 mt-5">Explore Our Partner Institutions</p>

             <Carousel
            responsive={responsiveCarousel}
            infinite
            autoPlay
            autoPlaySpeed={4000}
            arrows
            keyBoardControl
            showDots={false}
            containerClass="carousel-container-custom"
            itemClass="px-3"
            renderButtonGroupOutside={false}
          >
            {AustraliaUniversities.map((univ, idx) => {
              const content = (
                <div className="bg-white mt-10 rounded-lg shadow hover:shadow-lg transition-all duration-300 p-4 text-center h-full flex flex-col items-center justify-between">
                  <img
                    src={univ.img}
                    alt={univ.title}
                    className="rounded-md max-h-36 w-full object-contain mb-3"
                    loading="lazy"
                  />
                  <h5 className="text-sm font-medium text-gray-700">{univ.title}</h5>
                </div>
              );
              return univ.link ? (
                <Link key={idx} to={univ.link}>
                  {content}
                </Link>
              ) : (
                <div key={idx}>{content}</div>
              );
            })}
          </Carousel>

        </div>

        {/* Rest of the Section */}
        <h2 className="text-2xl text-indigo-600 font-semibold mb-4">{AustraliaData.mTitle}</h2>
        <p className="text-gray-700 mb-3 leading-relaxed">{AustraliaData.desc_1}</p>
        <p className="text-gray-700 leading-relaxed">{AustraliaData.desc_2}</p>
        
         <img
          src="/image/about/about-07/australia.png"
          alt="Study in Australia"
          className="w-[30%] h-[30%] mx-auto mt-6 rounded-lg object-cover shadow"
        />
        
      </section>

      {/* Features Section */}
      <section className="mb-16">
        <h3 className="text-xl font-semibold text-gray-800 mb-4 mt-5">Key Benefits of Studying in the Australia</h3>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {AustraliaBenefits.map((item, idx) => (
            <div key={idx} className="bg-white p-6 rounded-xl shadow-md text-center border border-gray-100">
              <div className="text-3xl font-bold text-indigo-600">
                {item.number}
                {item.suffix}
              </div>
              <p className="mt-2 text-lg font-medium text-gray-700">{item.title}</p>
            </div>
          ))}
        </div>
      </section>

      {/* CTA Section */}
      <div className="text-center mt-12">
        <button
          onClick={() => navigate("/contact-us")}
          className="bg-indigo-600 text-white px-6 py-3 rounded-lg text-lg font-semibold hover:bg-indigo-700 transition"
        >
          Apply Now!
        </button>
      </div>
    </div>
  );
};

export default AboutCountryAustralia;





